import { FC, PropsWithChildren } from 'react';

import { useIsApiHealthy } from 'app/hooks';
import MaintenancePage from 'app/pages/error/MaintenancePage';
import LoadingScreen from 'app/pages/shared/LoadingScreen';

// Component Definition
const APIHealthCheck: FC<PropsWithChildren> = props => {
  const apiHealth = useIsApiHealthy();

  if (!apiHealth.hasHealthStatus) {
    return <LoadingScreen />;
  }

  if (!apiHealth.isHealthy) {
    return <MaintenancePage />;
  }

  return props.children;
};

export default APIHealthCheck;
